<template>
  <NuxtLink
    :to="to"
    :target="target"
    :rel="rel"
    :class="className"
    :style="style"
    v-bind="$attrs"
  >
    <slot></slot>
  </NuxtLink>
</template>

<script setup lang="ts">
  interface Props {
    to: string;
    target?: string;
    rel?: string;
    className?: string;
    style?: Record<string, string>;
  }
  withDefaults(defineProps<Props>(), {
    target: '_self',
    rel: 'noopener noreferrer',
    className: '',
    style: () => ({})
  });
</script>
